import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getLiksUnlikes, giveLikesUnlikes } from "./likeUnlikeApi";

const initialState = {
  likes: null,
  unlikes: null,
};

export const fetchLikesUnlikes = createAsyncThunk(
  "likesUnlikes/fetchLikesUnlikes",
  async (id) => {
    const video = await getLiksUnlikes(id);
    return video;
  }
);

export const LikesUnlikes = createAsyncThunk(
  "likesUnlikes/givelikeUnlike",
  async ({ id, likesOrUnlikesNo, likesOrUnlikes }) => {
    const likesUnlikesVideo = await giveLikesUnlikes(
      id,
      likesOrUnlikesNo,
      likesOrUnlikes
    );
    return likesUnlikesVideo;
  }
);

const likesUnlikesSlice = createSlice({
  name: "likesUnlikes",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchLikesUnlikes.fulfilled, (state, action) => {
        state.likes = action.payload.likes;
        state.unlikes = action.payload.unlikes;
      })
      .addCase(LikesUnlikes.fulfilled, (state, action) => {
        state.likes = action.payload.likes;
        state.unlikes = action.payload.unlikes;
      });
  },
});

export default likesUnlikesSlice.reducer;
